<article class="formEditor">
    <span class="formLabel">{{ labelText() }}</span>
    @if (multiple()) {
        <lib-generic-type-ahead-multiselect
            [source]="items()"
            [selectedItems]="selectedItems()"
            (selectedItemsChange)="onSelectedItemsChange($event)"
            [config]="{
                defaultText: placeholderText(),
                multiple: multiple(),
                itemDisplayKey: 'name'
            }"
            [placeholder]="placeholderText()"
            (textChange)="onEntityTextChange($event)"
            [isReadOnly]="isReadOnly()"
            id="mainContact"
        >
        </lib-generic-type-ahead-multiselect>
    } @else {
        <lib-generic-type-ahead-dropdown
            [source]="items()"
            [selectedItem]="selectedItem()"
            (selectedItemChange)="onSelectedItemChange($event)"
            [config]="{
                defaultText: placeholderText(),
                itemDisplayKey: 'fullName',
                isActive: selectedItem()?.isActive ?? true
            }"
            [placeholder]="placeholderText()"
            (textChange)="onEntityTextChange($event)"
            [isReadOnly]="isReadOnly()"
            id="mainContact"
        >
        </lib-generic-type-ahead-dropdown>
    }
</article>
